// Shared helpers for store_items.rarity (WS-10) — one place mapping the
// common|uncommon|rare|epic|legendary enum to display label, colour, and the
// elevation.css glow tokens, so every surface (store cards, inventory rows,
// badge chips, admin editor) stays visually consistent.

import type { StoreItemRarity } from "../api/store";

const LABELS: Record<StoreItemRarity, string> = {
  common: "Common",
  uncommon: "Uncommon",
  rare: "Rare",
  epic: "Epic",
  legendary: "Legendary",
};

const COLOR_VARS: Record<StoreItemRarity, string> = {
  common: "var(--rarity-color-common)",
  uncommon: "var(--rarity-color-uncommon)",
  rare: "var(--rarity-color-rare)",
  epic: "var(--rarity-color-epic)",
  legendary: "var(--rarity-color-legendary)",
};

const GLOW_SM: Record<StoreItemRarity, string | undefined> = {
  common: undefined,
  uncommon: "var(--glow-rarity-uncommon-sm)",
  rare: "var(--glow-rarity-rare-sm)",
  epic: "var(--glow-rarity-epic-sm)",
  legendary: "var(--glow-rarity-legendary-sm)",
};

const GLOW_MD: Record<StoreItemRarity, string | undefined> = {
  common: undefined,
  uncommon: "var(--glow-rarity-uncommon-md)",
  rare: "var(--glow-rarity-rare-md)",
  epic: "var(--glow-rarity-epic-md)",
  legendary: "var(--glow-rarity-legendary-md)",
};

export const RARITY_OPTIONS: StoreItemRarity[] = ["common", "uncommon", "rare", "epic", "legendary"];

export function rarityLabel(rarity: StoreItemRarity | undefined | null): string {
  return LABELS[rarity ?? "common"] ?? "Common";
}

export function rarityColor(rarity: StoreItemRarity | undefined | null): string {
  return COLOR_VARS[rarity ?? "common"] ?? COLOR_VARS.common;
}

/** Small glow — badge chips, inventory-row borders. Undefined for common (no glow). */
export function rarityGlowSm(rarity: StoreItemRarity | undefined | null): string | undefined {
  return GLOW_SM[rarity ?? "common"];
}

/** Larger glow — store/collectible cards. Undefined for common (no glow). */
export function rarityGlowMd(rarity: StoreItemRarity | undefined | null): string | undefined {
  return GLOW_MD[rarity ?? "common"];
}
